<template>
  <div class="columns is-centered">
    <div class="column is-12">
      <div class="field">
        <label class="label">Name</label>
        <div class="control">
          <input v-model="name" class="input" type="text" placeholder="Name">
        </div>
      </div>

      <div class="field">
        <label class="label">Email</label>
        <div class="control">
          <input v-model="email" class="input" type="text" placeholder="Email">
        </div>
      </div>

      <div class="field">
        <label class="label">Password</label>
        <div class="control">
          <input v-model="password" class="input" type="password" placeholder="Password">
        </div>
      </div>

      <div class="field">
        <label class="label">Confirm Password</label>
        <div class="control">
          <input
            v-model="password_confirmation"
            class="input"
            type="password"
            placeholder="Confirm Password"
          >
        </div>
      </div>

      <div class="field">
        <div class="control">
          <button class="button is-primary" type="submit" @click.prevent="register">
            Register
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import REGISTER from '@/graphql/user/register.gql';
import { onLogin } from '../../vue-apollo';

export default {
  name: 'Register',
  data() {
    return {
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
    };
  },
  methods: {
    register() {
      this.$apollo.mutate({
        mutation: REGISTER,
        variables: {
          name: this.name,
          email: this.email,
          password: this.password,
          passwordConfirmation: this.password_confirmation,
        },
      })
        .then((res) => {
          onLogin(this.$apollo.getClient(), res.data.register.access_token);
          this.$router.push({ name: 'dashboard' });
          this.$toasted.success('Registered!');
        })
        .catch((error) => {
          this.$toasted.error(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
